import React from 'react'
import { Button, DialogActions, DialogContent, Typography } from '@mui/material'
import { BootstrapDialog, BootstrapDialogTitle } from '../../../assets/theme/theme'
import styles from './ProjectStatusChangePopup.module.scss'

const ProjectStatusChangePopup: React.FC<{
  isStatusChangeDialogOpen: boolean;
  projectStatusChangeClick(): void;
  projectStatusChange(): void;
  isStatusChangeRow: any;
}> = (props) => {
  return (
    <BootstrapDialog
      className={styles.dialogCard}
      aria-labelledby="customized-dialog-title"
      open={props.isStatusChangeDialogOpen}
    >
      <BootstrapDialogTitle id="customized-dialog-title"
        onClose={() => props.projectStatusChangeClick()
        }
      >
        Please Confirm

      </BootstrapDialogTitle>
      <DialogContent dividers className='dialogContainer'>

        {props.isStatusChangeRow.projectStatus.value.isEnabled === true &&
          <Typography gutterBottom>
            {`Do you want to Disable the "${props.isStatusChangeRow.projectStatus.value.teamName}"`}
          </Typography>
        }
        {props.isStatusChangeRow.projectStatus.value.isEnabled === false &&
          <Typography gutterBottom>
            {`Do you want to Enable the "${props.isStatusChangeRow.projectStatus.value.teamName}"`}
          </Typography>
        }

      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.projectStatusChange()}
          autoFocus variant="contained"
          className={'btnStyle'}
        >
          Confirm
        </Button>
        <Button onClick={() => props.projectStatusChangeClick()}
          autoFocus variant="contained"
          className={'btnStyle'}
          color={'inherit'}

        >
          Cancel
        </Button>
      </DialogActions>
    </BootstrapDialog>

  )
}

export default ProjectStatusChangePopup
